'use es6';

import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import { updatePartitioning } from 'FileManagerCore/actions/Partitioning';
import { closeModal } from '../../actions/Actions';
import { RequestStatus } from 'FileManagerCore/Constants';
import { getPartitioningStatus } from '../../selectors/ModalDisplay';
import WithUsersAndTeamsDataFetching from 'ui-asset-management-lib/utils/WithUsersAndTeamsDataFetching';
import TeamsAssetAccessPanel from 'ui-asset-management-lib/components/TeamsAssetAccessPanel';
import I18n from 'I18n';
import { getFolders, getParentFolderForObject } from '../../selectors/FoldersAndFiles';
import getAllowedTeamIds from '../../utils/getAllowedTeamIds';
import getAffectedParentFolder from '../../utils/getAffectedParentFolder';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILink from 'UIComponents/link/UILink';
import UIIcon from 'UIComponents/icon/UIIcon';
import { getOnlyLeafTeams } from 'FileManagerCore/utils/teams';
import { trackInteraction } from 'FileManagerCore/actions/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getI18nKey = suffix => `FileManagerDashboard.partitionFolderModal.${suffix}`;
const AccessPanel = WithUsersAndTeamsDataFetching(props => /*#__PURE__*/_jsx(TeamsAssetAccessPanel, Object.assign({}, props, {
  allowedTeamIds: getAllowedTeamIds(props),
  onSave: data => props.onSave(data, props.teams),
  baseAccessValue: "SELECTED_TEAMS_VIEW_AND_EDIT"
})));
const PartitionFolderModal = ({
  object: folder,
  parentFolder,
  dispatch,
  status,
  bulkFolders,
  folders
}) => {
  useEffect(() => {
    if (status === RequestStatus.SUCCEEDED) {
      setTimeout(() => dispatch(closeModal()), 200);
    }
  }, [status, dispatch]);
  const teams = folder ? folder.get('teams').toArray() : [];
  const parentTeams = parentFolder.get('id') ? parentFolder.get('teams').toArray() : [];
  const save = ({
    selectedTeamIds
  }, allTeams) => {
    dispatch(trackInteraction('fileManagerManageFolders', 'partition-folder', {
      teamCount: selectedTeamIds.length,
      isTopLevel: parentFolder.get('id') === null
    }));
    dispatch(updatePartitioning(folder ? Immutable.Set([folder.get('id')]) : bulkFolders.map(f => f.get('id')), getOnlyLeafTeams(allTeams, selectedTeamIds)));
  };
  const cancel = () => dispatch(closeModal());
  const getDisableTooltip = ({
    teamName,
    teamId
  }) => {
    const affectedParentFolder = getAffectedParentFolder(teamId, folder, folders);
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: getI18nKey('disabledTooltip'),
      options: {
        folderName: /*#__PURE__*/_jsx("strong", {
          children: folder.get('name')
        }),
        teamName: /*#__PURE__*/_jsx("strong", {
          children: teamName
        }),
        parentFolder: /*#__PURE__*/_jsxs(UILink, {
          href: `?folderId=${affectedParentFolder.get('id')}`,
          style: {
            fontWeight: 'bold',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
          },
          children: [/*#__PURE__*/_jsx(UIIcon, {
            className: "m-all-0 m-right-1",
            name: "folder"
          }), affectedParentFolder.get('name')]
        })
      }
    });
  };
  return /*#__PURE__*/_jsx(AccessPanel, {
    "data-test-id": "access-panel",
    assignedTeamIds: teams,
    parentTeams: parentTeams,
    onSave: save,
    onCancel: cancel,
    assetTypeDisplayName: folder ? folder.get('name') : I18n.text(getI18nKey('bulkFolders'), {
      count: bulkFolders.size
    }),
    disallowedTeamFormattedMessage: getDisableTooltip
  });
};
PartitionFolderModal.reduxProps = {
  status: PropTypes.string,
  parentFolder: PropTypes.instanceOf(Immutable.Map),
  dispatch: PropTypes.func.isRequired,
  folders: PropTypes.instanceOf(Immutable.List)
};
PartitionFolderModal.propTypes = Object.assign({}, PartitionFolderModal.reduxProps, {
  object: PropTypes.instanceOf(Immutable.Map),
  bulkFolders: PropTypes.instanceOf(Immutable.Set)
});
const mapStateToProps = (state, props) => ({
  status: getPartitioningStatus(state),
  parentFolder: getParentFolderForObject(state, props),
  folders: getFolders(state)
});
export default connect(mapStateToProps)(PartitionFolderModal);